import state from './peopleState.js'
import actions from './peopleActions.js'
import mutations from './peopleMutations.js'

export default {
  state,
  actions,
  mutations,
}
